import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import AccountLoged from "@/shared/mixins/AccountLoged";

import gButton from "@/components/g-button/g-button.vue";
import gDateInput from "@/components/g-date-input/g-date-input";
import GerenciamentoLogController from "@/shared/controllers/gerenciamentoLog/gerenciamentoLogController";
import FiltroConsultarLog from "@/shared/view-models/Filtros/FiltroConsultarLog";
import DataGrid from "@/components/DataGrid/DataGrid.vue"
import { coluna } from "@/components/DataGrid/DataGridFuncsAux/dataGridFuncs";
// import { onMounted } from "vue";
import { useGrid } from "@/shared/services/tools";
import { defineComponent } from "vue";
import UsuarioController from "@/shared/controllers/usuario/usuarioController";
/// import GridParametros from "@/shared/services/GridParametros";

export default defineComponent({
  name:'GerenciamentoLog',
  components: { 
    gCard,
    gForm,
    'g-button': gButton,
    gDateInput,
    DataGrid
  }, 

  props: { },
  mixins:[AccountLoged],

  mounted () { 
    this.GetEnumDescricaoProcesso()
    this.GetAllNomesTabelasLog()
    if(!this.hasClaim('Gerenciamento-Log')) {
      this.$router.push('/sem-acesso')
    }
  },

  setup(){

       const { busca, filtros, parametros, filtrar, limpar } = useGrid()
    
       parametros.Filtros = filtros;
    
       parametros.OperacaoRemota = true;
    
       parametros.Paginacao.pagina = 1;
    
       parametros.Paginacao.quantidade = 15;

       
    
      //  onMounted(() => { busca.value++ })
    
    return { busca, filtros, filtrar, limpar , parametros};
    
     },

  updated () { },

  data () {
    return { 
      outrosParametros:[],
      LogArray: [],
      UsuarioArray: [],
      ProcessoArray: [],
      objFiltro: new FiltroConsultarLog(),
      TabelasArray: [],   
    //   Colunas : [
    //     //Campo dos dados , nome que aparece na página
    //     {field: 'userName', header: 'Usuário', width: '120px', ordena: true},
    //     {field: 'descricaoProcessoTexto', header: 'Descrição Processo', width: '280px', ordena: true},
    //     {field: 'operacaoTexto', header: 'Operação', width: '240px', ordena: true},
    //     {field: 'nomeTabela', header: 'Tabela', width: '100px', ordena: true},
    //     {field: 'dataLogFormatada', header: 'Data Log', width: '180px', ordena: true},
    //     {field: 'numeroIP', header: 'IP', width: '240px', ordena: true},

    // ],
    rota: process.env.VUE_APP_WEB_API + 'Log/GetLogByFiltro',
    Colunas:  [
      coluna('Usuário', 'userName', '18%', {campoBusca: 'userName'}),
      coluna('Descrição Processo', 'descricaoProcessoTexto', '25%', {campoBusca: 'DescricaoProcesso'}),
      coluna('Operação', 'operacaoTexto', '18%'),
      coluna('Tabela', 'nomeTabela', '18%'),
      coluna('Data Log', 'dataLogFormatada', '18%'),
      coluna('IP', 'numeroIP', '18%')
    ],
    valores: [],
    Filtro: {
      'global': {value: null, matchMode: this.filtros.CONTAINS},
      'userName': {value: null, matchMode: this.filtros.CONTAINS},
      'dataLogFormatada': {value: null, matchMode: this.filtros.CONTAINS},
      'nomeTabela' : {value: null, matchMode: this.filtros.CONTAINS},
      'descricaoProcessoTexto': {value: null, matchMode: this.filtros.CONTAINS},
      'operacaoTexto' : {value: null, matchMode: this.filtros.CONTAINS},
    },
    }
  },

  methods: { 
    limpaFiltro() {
      this.objFiltro = new FiltroConsultarLog()
    },
    Grid(){

      if(this.objFiltro.Inicio != undefined || this.objFiltro.Fim != undefined ) {
        this.parametros.Periodo.campo='DataLog'
        this.parametros.Periodo.inicio = this.objFiltro.Inicio
        this.parametros.Periodo.fim = this.objFiltro.Fim
      }
      if(this.objFiltro.Acesso) this.insertOrUpdateFiltro('Operacao', 0, false, true)
      if(this.objFiltro.Consulta) this.insertOrUpdateFiltro('Operacao', 1, false, true)
      if(this.objFiltro.Inclusao) this.insertOrUpdateFiltro('Operacao', 2, false, true)
      if(this.objFiltro.Alteracao) this.insertOrUpdateFiltro('Operacao', 3, false, true)
      if(this.objFiltro.Exclusao) this.insertOrUpdateFiltro('Operacao', 4, false, true)
      if(this.objFiltro.Manutencao) this.insertOrUpdateFiltro('Operacao', 5, false, true)

      if(this.objFiltro.UsuarioId != undefined && this.objFiltro.UsuarioId != null ) this.insertOrUpdateFiltro('UsuarioId', this.objFiltro.UsuarioId, true)
      if(this.objFiltro.DescricaoProcesso != undefined) this.insertOrUpdateFiltro('DescricaoProcesso', this.objFiltro.DescricaoProcesso, false)

      //this.insertOrUpdatePeriodo('Inicio', this.objFiltro.Periodo, false)
      this.getLogByFiltro()     
      this.busca++
    },

    getLogByFiltro(){
      this.$isLoading(true)
      // this.gridParametroObjetoAuxiliar.GridParametro.Filtros = [{Campo:'Clienteid', Valor : `${clienteId}` }]
      // this.parametros.Filtros=[
      //   {campo:"usuarioId" , valor :this.objFiltro.UsuarioId}
      // ]
      GerenciamentoLogController.getLogByFiltro(this.parametros).requisicao
        .then((response) =>{
            this.LogArray = response.data.data
        }).finally(() => this.$isLoading(false))
    },
    insertOrUpdateFiltro(chave, valor, like, isEnum = false){
      if(isEnum) {
        var obj = this.filtros.findIndex(x => x.campo == chave && x.valor == valor)
        if(obj != -1){
          this.filtros[obj].valor = valor,
          this.filtros[obj].Enum = isEnum
          this.filtros[obj].like = isEnum
        }
        else {
          this.filtros.push({
            campo: chave,
            valor: valor,
            like: !isEnum,
            Enum: isEnum
  
          })
        }

      } else {
         obj = this.filtros.find(x => x.campo == chave);
        if(obj){
          obj.valor = valor,
          obj.like = like
        }
        else {
          this.filtros.push({
            campo: chave,
            valor: valor,
            like: like 
          })
        }
      }
      
    },

    buscarUsuario(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        UsuarioController.getUsuarios(event).requisicao
        .then((res => {
          this.UsuarioArray = res.data.data
        }))
      }, 1000);
    },

    GetEnumDescricaoProcesso(){
      this.$isLoading(true)
      GerenciamentoLogController.GetEnumDescricaoProcesso().requisicao
        .then((response) =>{
            this.ProcessoArray = response.data
        }).finally(() => this.$isLoading(false))
    },

    GetAllNomesTabelasLog(){
      this.$isLoading(true)
      GerenciamentoLogController.GetAllNomesTabelasLog().requisicao
        .then((response) =>{
            this.TabelasArray = response.data.data
        }).finally(() => this.$isLoading(false))
    },
    
   },



  computed: { }, 

});